// @ts-nocheck
import Tag from "@insite/mobius/Tag";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    categoriesList?: string[];
    extendedStyles?: EventCategoriesStyles;
}

export interface EventCategoriesStyles {
    tagWrapper?: TagWrapperProps;
}

export const eventCategoriesStyles: EventCategoriesStyles = {
    tagWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    margin-bottom: ${pxToRem(5)};
                `,
            },
        },
    },
};

const EventCategories = ({ categoriesList, extendedStyles }: Props) => {
    if (categoriesList === undefined || !categoriesList.length) {
        return null;
    }

    const styles = useMergeProps(eventCategoriesStyles, extendedStyles);

    return (
        <TagWrapper {...styles.tagWrapper}>
            {categoriesList.map(item => (
                <Tag deletable={false} key={item}>
                    {item}
                </Tag>
            ))}
        </TagWrapper>
    );
};

export default EventCategories;
